

import SplashyName from './Subcomponents/SplashyName';
import NavBar from "./Subcomponents/NavBar";
import HomeInfo from "./Subcomponents/HomeInfo";
export default function Home() {

    return (
        <div>
        <NavBar />
        <SplashyName />
        <HomeInfo />
      </div>
    )
}